import { DocumentType, IdentityTypeCode } from '@verifime/utils';

// Hardcoded for now - future: fetched from workflow metadata API
export const DOCUMENT_REQUIREMENTS_INTRO =
  'Add documents that will assist in verifying this organisation based on your entity type:';

export const ADDITIONAL_DOCUMENTS_HEADING = 'Additional Documents (if applicable to your business)';

export const ADDITIONAL_DOCUMENTS = [
  'Dealer license, professional registration, or industry-specific permits',
];

// Shared document requirements
// Every entity document list in this file (COMPANY_DOCUMENTS, TRUST_DOCUMENTS and the Partnership
// and Sole_Trader entries of ENTITY_DOCUMENT_REQUIREMENTS) is copied word for word in
// verifime-email-templates, templates/customer-invitation/invitation-email.mjml and
// invitation-email.json (the plain text body). Change both together.
const COMPANY_DOCUMENTS = [
  'ASIC current company extract (if available)',
  'Constitution (if applicable)',
  'Shareholder agreement (if applicable)',
];

const TRUST_DOCUMENTS = [
  'Trust deed',
  'Any deed of variation to the trust',
];

// Only organisation entity types that are supported for document upload
export type TOrganisationEntityType = Exclude<IdentityTypeCode, IdentityTypeCode.Individual_Domestic>;

// Copied in the invite email: see the note above COMPANY_DOCUMENTS.
export const ENTITY_DOCUMENT_REQUIREMENTS: Record<TOrganisationEntityType, string[]> = {
  [IdentityTypeCode.Private_Company]: COMPANY_DOCUMENTS,
  [IdentityTypeCode.Public_Company]: COMPANY_DOCUMENTS,
  [IdentityTypeCode.Partnership]: [
    'Partnership agreement or deed',
    'Partnership register',
    'Any agreement or deed of variation',
    'Registration certificate (if registered)',
    'Australian Business Register extract showing the partnership ABN (if applicable)',
  ],
  [IdentityTypeCode.Trust_Regulated]: TRUST_DOCUMENTS,
  [IdentityTypeCode.Trust_Unregulated]: TRUST_DOCUMENTS,
  [IdentityTypeCode.SMSF]: TRUST_DOCUMENTS,
  [IdentityTypeCode.Sole_Trader]: [
    'Business registration certificate or Australian Business Register extract showing any applicable ABN',
    'Trade name registration (if applicable)',
  ],
};

// Map entity type to document type for API storage
export const ENTITY_TO_DOCUMENT_TYPE: Record<TOrganisationEntityType, DocumentType> = {
  [IdentityTypeCode.Private_Company]: DocumentType.CompanyExtract,
  [IdentityTypeCode.Public_Company]: DocumentType.CompanyExtract,
  [IdentityTypeCode.Partnership]: DocumentType.PartnershipAgreement,
  [IdentityTypeCode.Trust_Regulated]: DocumentType.TrustDeed,
  [IdentityTypeCode.Trust_Unregulated]: DocumentType.TrustDeed,
  [IdentityTypeCode.SMSF]: DocumentType.TrustDeed,
  [IdentityTypeCode.Sole_Trader]: DocumentType.SoleTraderSupportDocument,
};
